import { render, staticRenderFns } from "./reaction_bubble.vue?vue&type=template&id=4a01481a&"
import script from "./reaction_bubble.vue?vue&type=script&lang=js&"
export * from "./reaction_bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports